var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphicHeaderBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272.37 71.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            #graphic_header_big .cls-1 {\n                fill: #356359;\n            }\n\n            #graphic_header_big .cls-2 {\n                fill: #449e8a;\n            }\n\n            #graphic_header_big .cls-3 {\n                fill: #823312;\n            }\n\n            #graphic_header_big .cls-4 {\n                fill: #1a2442;\n            }\n\n            #graphic_header_big .cls-5 {\n                fill: #ae1831;\n            }\n\n            #graphic_header_big .cls-6 {\n                fill: #223361;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphic_header_big",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_2-2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.24,70.91V28.56l.13-.1V71h-22v-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.24,28.56V70.91H250.35A52.49,52.49,0,0,1,272.24,28.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.24.13V28.56a52.49,52.49,0,0,0-21.89,42.35H157.7A75.72,75.72,0,0,0,222.75,18.7,75.79,75.79,0,0,0,226.22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.37,0V28.46l-.13.1V.13h-46V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.35,70.91V71H156.16c.51,0,1-.08,1.54-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.35,71v.2H150.67c1.85,0,3.68-.07,5.49-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M226.22,0V.13H144L144.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144,.13h82.23a75.79,75.79,0,0,1-3.47,18.57H128.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84,70.91H157.7c-.51,0-1,.1-1.54.13H83.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.1,0,144,.13H0A.29.29,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.87,71h72.29c-1.81.13-3.64.2-5.49.2h-67l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128.24,18.7l-9.67,11.41-7.29,8.6h0L100.11,51.88,84,70.91H74.35a82,82,0,0,1-39-14A52.6,52.6,0,0,1,78.74,19.18a54,54,0,0,1,7.13-.48h42.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.75,18.7A75.72,75.72,0,0,1,157.7,70.91H84l16.13-19,11.16-13.17h0l7.29-8.6,9.67-11.41h94.51Zm-88,33.3a0,0,0,0,1,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84,70.91l-.11.13H76l-1.66-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.87,71l-.15.18-2,0c-1.94,0-3.86-.07-5.76-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.31,56.93A82.78,82.78,0,0,1,5,19,82.31,82.31,0,0,1,0,.13H144L128.24,18.7H85.87a54,54,0,0,0-7.13.48A52.6,52.6,0,0,0,35.31,56.93Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicHeaderBig);
export default __webpack_public_path__ + "static/media/graphic_header_big.78347c0205c5e8d2147ba4a4f6e951ce.svg";
export { ForwardRef as ReactComponent };